export function ExternalPlayScreen({
  title,
  emulatorName,
  platformLabel,
  iframeUrl,
  romFilename,
  launchStatus,
  onBack,
}) {
  const romPath = romFilename ? `/roms/${romFilename}` : null;

  return (
    <div className="play-screen play-screen--external">
      <header className="play-header">
        <button type="button" className="btn-back" onClick={onBack}>
          ← Biblioteca
        </button>
        <div className="play-header__meta">
          <h1 className="play-title">{title || platformLabel}</h1>
          <p className="play-subtitle">
            {emulatorName} · {platformLabel}
            {romPath ? (
              <>
                {' '}
                · <code className="play-rom-path">{romPath}</code>
              </>
            ) : null}
          </p>
        </div>
      </header>

      {launchStatus ? <p className="play-status play-status--external">{launchStatus}</p> : null}

      <div className="external-frame-wrap">
        {launchStatus && !iframeUrl ? (
          <div className="crt-loading is-active" role="status" aria-live="polite">
            <div className="crt-loading__spinner" aria-hidden="true" />
            <p className="crt-loading__text">{launchStatus}</p>
          </div>
        ) : iframeUrl ? (
          <iframe
            className="external-frame"
            src={iframeUrl}
            title={`${emulatorName} — ${title || platformLabel}`}
            allow="autoplay; fullscreen; gamepad; microphone; camera; clipboard-read; clipboard-write; screen-wake-lock"
          />
        ) : (
          <p className="rom-library-empty">Emulador indisponível.</p>
        )}
      </div>
    </div>
  );
}
